export default "__VITE_ASSET__CCjcsnK5__"